/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientContent } from '../../models/client-content';
import { CriteriaContentObject } from '../../models/criteria-content-object';

export interface ApiMasterClientContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterClientContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterClientContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterClientContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientContent>>;
    })
  );
}

apiMasterClientContentGetByCriteriaPost.PATH = '/api/Master/ClientContent/GetByCriteria';
